export const siteSettings = {
  name: "Penta Markets",
  link: "https://pentamarket.net",
  email: "support@pentamarket.net",
  appLink: "https://app.pentamarket.net",
};
